import React, { Component } from 'react';

import { Project } from './../../../classes/project.class';

import { ProjectListPageController } from './project-list.controller';

import ProjectComponent from './../../../components/project/project.component';

let controller;

class ProjectListPage extends Component {
    constructor(props) {
        super(props);
        controller = new ProjectListPageController({apiUrl: '/api', user: this.props.user});
        this.state = {
            projects: controller.getProjects()
        }
    }

    componentWillMount() {
        
        controller.on('updateProjects', () => {
            console.log(controller.getProjects());
            this.setState({projects: controller.getProjects()});
        });
        
    }

    _createProject() {
        controller.createProject();
    }

    render() {
        let projects = this.state.projects.map(project => {
            console.log(project.name);
            return <ProjectComponent project={project} updateProject={controller.updateProject.bind(controller)} deleteProject={controller.deleteProject.bind(controller)} />
        });

        return (
            
            <div>
                <h3>Projects</h3>



                <ul className="projects">
                    {projects}
                </ul>



                <button className="app-btn  app-btn--create" onClick={this._createProject.bind(this)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
            </div>
        );
    }
}

export default ProjectListPage;


// WEBPACK FOOTER //
// src/pages/project/list/project-list.page.js